import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spinner } from '@americanexpress/aqx-components';
import { getGlobalOgSpinnerText } from 'src/universal/redux/page';
import styles from './__styles__/index.scss?modules';

const OfferGatingSpinner = ({ modalData, spinnerText }) => {
  const needSpinner = (modalData || {}).needModalSpinner || false;

  useEffect(
    () => {
      const setPageScrollLock = (toLock = true) => {
        const method = toLock === true ? 'add' : 'remove';
        document.getElementsByTagName('body')[0].classList[method]('ogmodal-open');
      };

      setPageScrollLock(needSpinner);

      return () => {
        setPageScrollLock(false);
      };
    },
    [needSpinner]
  );

  return (
    <div className={styles.spinnerContainer} role="alert" tabIndex="-1">
      <Spinner
        $fullscreen
        $size="large"
        active={needSpinner}
        ariaLabel={spinnerText}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  modalData: state.modalData,
  spinnerText: getGlobalOgSpinnerText(state)
});

export default connect(mapStateToProps)(React.memo(OfferGatingSpinner));
